import { buildTickerKeywords } from "./buildTickerKeywords";
import { getTwoPartTicker } from "~utils/getTwoPartTicker";

const KEYWORDS = [
  "spot",
  "spot index",
  "spot rate",
  "forex rate",
  "foreign exchange rate",
];
const TWO_PART_KEYWORDS = ["buying", "selling", "asking price"];

interface BuildCURKeywords {
  displayName: string;
  securityName: string;
  ticker: string;
}

export function buildCURKeywords({
  displayName,
  ticker,
  securityName,
}: BuildCURKeywords) {
  const { firstName, firstTicker, secondName, secondTicker, isTwoPartTicker } =
    getTwoPartTicker(securityName, ticker);

  if (!isTwoPartTicker) {
    return buildTickerKeywords(displayName, ticker, KEYWORDS);
  }

  return [
    firstName,
    firstTicker,
    secondName,
    secondTicker,
    "conversion chart",
    `${firstName} exchange rate`,
    `${secondName} exchange rate`,
    buildTickerKeywords(firstName, firstTicker, TWO_PART_KEYWORDS),
    buildTickerKeywords(secondName, secondTicker, TWO_PART_KEYWORDS),
  ].join(", ");
}
